
export const secondYear = [
    
    {
        "url": require('../Assets/2ndYearImg/Aniketh Kumar Yadav.webp'),
        "name": "Aniketh Kumar Yadav",
        "instaLink": "",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/2ndYearImg/Ansh Bhaladhare.webp'),
        "name": "Ansh Bhaladhare",
        "instaLink": "",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/2ndYearImg/Anubhab Ghosh.webp'),
        "name": "Anubhab Ghosh",
        "instaLink": "",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/2ndYearImg/ARADHY SONI.webp'),
        "name": "Aradhy Soni",
        "instaLink": "",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/2ndYearImg/Arman Sahoo.webp'),
        "name": "Arman Sahoo",
        "instaLink": "",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/2ndYearImg/Ashish Kumar.webp'),
        "name": "Ashish Kumar",
        "instaLink": "",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/2ndYearImg/Ayan Sarkar.webp'),
        "name": "Ayan Sarkar",
        "instaLink": "",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/2ndYearImg/B.P.S.Sasank.webp'),
        "name": "B.P.S. Sasank",
        "instaLink": "",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/2ndYearImg/Diganta kar.webp'),
        "name": "Diganta Kar",
        "instaLink": "",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/2ndYearImg/Harish V.webp'),
        "name": "Harish V",
        "instaLink": "",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/2ndYearImg/Imran Barik.webp'),
        "name": "Imran Barik",
        "instaLink": "",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/2ndYearImg/Jasmitha.webp'),
        "name": "Jasmitha",
               "instaLink": "",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/2ndYearImg/Lalit Kumar Raul.webp'),
        "name": "Lalit Kumar Raul",
        "instaLink": "",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/2ndYearImg/Kasam Nikhil.webp'),
        "name": "Kasam Nikhil",
        "instaLink": "",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/2ndYearImg/Jeevan P.webp'),
        "name": "Jeevan P.S",
        "instaLink": "",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/2ndYearImg/Maheedhar.webp'),
        "name": "Maheedhar",
        "instaLink": "",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/2ndYearImg/Maya Shankar.webp'),
        "name": "Maya Shankar",
        "instaLink": "",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/2ndYearImg/Mohammed Zayan .webp'),
        "name": "Mohammed Zayan",
        "instaLink": "https://www.instagram.com/mohammed.zayan?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/2ndYearImg/OM YADAV.webp'),
        "name": "Om Yadav",
        "instaLink": "",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/2ndYearImg/Palisetty sujith.webp'),
        "name": "Palisetty Sujith",
        "instaLink": "",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/2ndYearImg/Pragya Nandi.webp'),
        "name": "Pragya Nandi",
        "instaLink": "",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/2ndYearImg/Priyanka Dutta.webp'),
        "name": "Priyanka Dutta",
        "instaLink": "",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/2ndYearImg/Puja Marrivada .webp'),
        "name": "Puja Marrivada",
        "instaLink": "",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/2ndYearImg/Reswanth.webp'),
        "name": "Reswanth Veerendra",
        "instaLink": "",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/2ndYearImg/S.Likitha sri.webp'),
        "name": "S. Likitha Sri",
                "instaLink": "",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/2ndYearImg/SABIK_KUNDU.webp'),
        "name": "Sabik Kundu",
        "instaLink": "",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/2ndYearImg/SAHIL ALI.webp'),
        "name": "Sahil Ali",
        "instaLink": "",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/2ndYearImg/Saivarun.webp'),
        "name": "Saivarun",
               "instaLink": "",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/2ndYearImg/Shruti Nath.webp'),
        "name": "Shruti Nath",
        "instaLink": "",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/2ndYearImg/Shubham Mondal.webp'),
        "name": "Shubham Mondal",
        "instaLink": "",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/2ndYearImg/SOHAM RANA.webp'),
        "name": "Soham Rana",
               "instaLink": "",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/2ndYearImg/Sreejan Paul.webp'),
        "name": "Sreejan Paul",
        "instaLink": "",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/2ndYearImg/vishalreddy.webp'),
        "name": "Vishal Reddy",
        "instaLink": "",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/2ndYearImg/Yaswanth.webp'),
        "name": "Yaswanth",
        "instaLink": "",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/2ndYearImg/Yuvika Gupta.webp'),
        "name": "Yuvika Gupta",
        "instaLink": "",
        "linkedinLink": "",
    },

]
